import TranslationClickListener from 'components/translation-click-listener/TranslationClickListener';
import Wizard from 'features/wizard/components/Wizard';
import useOpenHelpCenter from 'hooks/help-center/useOpenHelpCenter';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const SETUP_GUIDE_HELP_CENTER_ARTICLE_ID = 8262817;

// Wraps Wizard with the dashboard-specific setup-guide subtitle, including its "Learn more" link
// to the help center article — kept separate from DashboardComponents so that concern (and its
// hooks) doesn't leak into the rest of the dashboard.
export const WizardDashboard: React.FC = () => {
    const { t } = useTranslation();

    const openSetupGuideHelpCenter = useOpenHelpCenter(
        SETUP_GUIDE_HELP_CENTER_ARTICLE_ID,
        'article',
        'setup_guide_help_center'
    );

    const wizardSubtitle = useMemo(
        () => (
            <TranslationClickListener id="open_setup_guide_help_center" action={openSetupGuideHelpCenter}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: t('DASHBOARD.STEP_GUIDE.SUBTITLE'),
                    }}
                />
            </TranslationClickListener>
        ),
        [t, openSetupGuideHelpCenter]
    );

    return <Wizard subtitle={wizardSubtitle} />;
};
